var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getEVMRpcClient } from '../../network/utils/getRpcClient';
import { ChainId, GasSetting } from '../../../config/networks';
/**
 * Calculates the gas settings for a given set of transactions on a specified network.
 *
 * @param {Object} params - The parameters for calculating gas settings.
 * @param {ChainId} params.network - The network on which the transactions will be executed.
 * @param {Array<Transaction>} params.transactions - The list of transactions to estimate gas for.
 * @param {GasSetting} [params.gasSetting=GasSetting.MARKET] - The gas setting multiplier to apply (default is Market with 1x multiplier).
 * @returns {Promise<GasEstimation>} A promise that resolves to the gas estimation settings.
 *
 * @throws {Error} If the network is unsupported or if there is an error fetching gas settings.
 */
export function calculateGasSettings(_a) {
    return __awaiter(this, arguments, Promise, function (_b) {
        var client, estimation, gasEstimates, _c, _d, block, suggestedMaxPriorityFeePerGas, baseFeePerGas, minimumTipGwei, maxPriorityFeePerGas, maxFeePerGas, gasPrice, multiplier_1, error_1;
        var _e, _f, _g;
        var network = _b.network, transactions = _b.transactions, _h = _b.gasSetting, gasSetting = _h === void 0 ? GasSetting.MARKET : _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    client = getEVMRpcClient({ chainId: network });
                    console.log('Executing order evm rpc client', client);
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 9, , 10]);
                    estimation = void 0;
                    return [4 /*yield*/, Promise.all(transactions.map(function (tx) { return client.estimateGas(tx); }))];
                case 2:
                    gasEstimates = _j.sent();
                    console.log('Executing order gasEstimates', gasEstimates);
                    _c = network;
                    switch (_c) {
                        case ChainId.ETHEREUM: return [3 /*break*/, 3];
                        case ChainId.ARBITRUM: return [3 /*break*/, 3];
                        case ChainId.OPTIMISM: return [3 /*break*/, 3];
                        case ChainId.BASE: return [3 /*break*/, 3];
                        case ChainId.POLYGON: return [3 /*break*/, 3];
                        case ChainId.AVALANCHE: return [3 /*break*/, 3];
                        case ChainId.BSC: return [3 /*break*/, 5];
                    }
                    return [3 /*break*/, 7];
                case 3: return [4 /*yield*/, Promise.all([
                        client.getBlock(),
                        client.estimateMaxPriorityFeePerGas(),
                    ])];
                case 4:
                    _d = _j.sent(), block = _d[0], suggestedMaxPriorityFeePerGas = _d[1];
                    baseFeePerGas = block.baseFeePerGas;
                    console.log('Executing order baseFeePerGas', baseFeePerGas);
                    minimumTipGwei = BigInt(2 * Math.pow(10, 9));
                    console.log('Executing order minimumTipGwei', minimumTipGwei);
                    maxPriorityFeePerGas = suggestedMaxPriorityFeePerGas > minimumTipGwei
                        ? suggestedMaxPriorityFeePerGas * 2n
                        : minimumTipGwei * 2n;
                    console.log('Executing order maxPriorityFeePerGas', maxPriorityFeePerGas);
                    maxFeePerGas = baseFeePerGas * 2n + maxPriorityFeePerGas;
                    console.log('Executing order maxFeePerGas', maxFeePerGas);
                    estimation = {
                        gasPrice: maxFeePerGas, // For backwards compatibility
                        maxFeePerGas: maxFeePerGas,
                        maxPriorityFeePerGas: maxPriorityFeePerGas,
                        gasEstimations: gasEstimates,
                    };
                    return [3 /*break*/, 8];
                case 5: return [4 /*yield*/, client.getGasPrice()];
                case 6:
                    gasPrice = _j.sent();
                    estimation = {
                        gasPrice: gasPrice,
                        gasEstimations: gasEstimates,
                    };
                    return [3 /*break*/, 8];
                case 7: throw new Error("Unsupported network: ".concat(network));
                case 8:
                    multiplier_1 = gasSetting;
                    console.log('Executing order starting return Executing order', estimation);
                    return [2 /*return*/, {
                            gasPrice: BigInt(Math.floor(Number((_e = estimation.gasPrice) === null || _e === void 0 ? void 0 : _e.toString()) * multiplier_1)),
                            maxFeePerGas: estimation.maxFeePerGas
                                ? BigInt(Math.floor(Number((_f = estimation.maxFeePerGas) === null || _f === void 0 ? void 0 : _f.toString()) * multiplier_1))
                                : undefined,
                            maxPriorityFeePerGas: estimation.maxPriorityFeePerGas
                                ? BigInt(Math.floor(Number((_g = estimation.maxPriorityFeePerGas) === null || _g === void 0 ? void 0 : _g.toString()) * multiplier_1))
                                : undefined,
                            gasEstimations: estimation.gasEstimations.map(function (estimate) {
                                return BigInt(Math.floor(Number(estimate === null || estimate === void 0 ? void 0 : estimate.toString()) * multiplier_1));
                            }),
                        }];
                case 9:
                    error_1 = _j.sent();
                    console.log("Error fetching gas settings: ".concat(error_1));
                    throw error_1;
                case 10: return [2 /*return*/];
            }
        });
    });
}
